const ImagesMode = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M212.31-140Q182-140 161-161t-21-51.31v-535.38Q140-778 161-799t51.31-21h535.38Q778-820 799-799t21 51.31v535.38Q820-182 799-161t-51.31 21zm0-60h535.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-535.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H212.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v535.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85M270-290h423.07L561.54-465.38 449.23-319.23l-80-102.31zm-70 90v-560zm140-370q20.77 0 35.38-14.62Q390-599.23 390-620t-14.62-35.38Q360.77-670 340-670t-35.38 14.62Q290-640.77 290-620t14.62 35.38Q319.23-570 340-570" />
        </svg>
    )
}

export default ImagesMode;

